import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
// import OutsideClickDetector from '../OutsideClickDetector';

const SuccessModal = ({ thank_you: { message }, setShow }) => {
  const portalContainer = document.createElement('div');
  portalContainer.classList = 'c-dialog c-dialog--thank-you';
  portalContainer.role = 'dialog';
  // portalContainer.ariaHidden = 'true';

  useEffect(() => {
    document.body.appendChild(portalContainer);

    return () => {
      document.body.removeChild(portalContainer);
    };
  }, [portalContainer]);

  return ReactDOM.createPortal(
    <>
      <div
        className="c-dialog__overlay"
        tabIndex="-1"
        data-a11y-dialog-hide
      ></div>

      <div
        className="c-dialog__container"
        role="dialog"
        aria-labelledby="dialog-title"
      >
        <button
          data-a11y-dialog-hide=""
          className="c-dialog__close"
          onClick={() => setShow(false)}
        >
          Close
        </button>

        <div className="c-dialog__content">
          <div className="c-form__finish">
            <div dangerouslySetInnerHTML={{ __html: message }}></div>
          </div>
        </div>
      </div>
    </>,
    portalContainer
  );
};

export default SuccessModal;
